import { paywallExperiments } from 'common/billing/experiments'
import { UpgradeSource } from 'common/billing/interfaces/upgradeSource'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'

import { MigrationWinbackPlansView } from './MigrationWinback'

// Internal-test-only mock: reuses ENABLE_PRO_V3_MIGRATION rather than a dedicated
// `enable_paywall_experiment_*` flag, so the `as TSFixMe` bypasses that type constraint.
paywallExperiments.register({
  accountFlag: AccountFlag.ENABLE_PRO_V3_MIGRATION,
  views: {
    Plans: MigrationWinbackPlansView,
  },
  sources: [UpgradeSource.WINBACK],
} as TSFixMe)
